export const validTrialExplorationFeatures = ['sequences', 'prospectingWorkspace', 'workflows', 'forecasting', 'quotes', 'playbooks'];